import React from "react";

const ClickupIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.30005 30.7407L9.44456 26.0336C12.7091 30.2942 16.1775 32.2581 20.0381 32.2581C23.8781 32.2581 27.2484 30.3174 30.3659 26.0903L36.5981 30.6839C32.1 36.7794 26.5104 40 20.0381 40C13.5865 40 7.94263 36.8 3.30005 30.7407Z",
  fill: "url(#paint0_linear_2785_860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.0174 10.2813L9.08063 19.7058L4.02515 13.8426L20.0406 0.0413208L35.9297 13.8529L30.851 19.6955L20.0174 10.2813Z",
  fill: "url(#paint1_linear_2785_860)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2785_860",
  x1: 3.30005,
  y1: 35.5322,
  x2: 36.5981,
  y2: 35.5322,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8930FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#49CCF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2785_860",
  x1: 4.02515,
  y1: 13.4152,
  x2: 35.9297,
  y2: 13.4152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF02F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC800"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_860"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ClickupIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;